import { Route, useRecoverableTerminalErrorRoute } from '../../config/router'
import { useConsumerLendingEligible, useCheckoutState, useIsRecoverableFlow, usePaymentTypeAllowInConvergence, useIsInlinePaymentOptions } from '../../state'
import { PaymentType } from '@afterpay/types'
import { CheckoutStatus } from '../../model'

export const usePostLoginRoute = (): Route => {
  const isConsumerLendingEligible = useConsumerLendingEligible()
  const { status } = useCheckoutState()
  const isRecoverableFlow = useIsRecoverableFlow()
  const recoverableRoute = useRecoverableTerminalErrorRoute()
  const isConsumerLendingAllowInConvergence = usePaymentTypeAllowInConvergence(PaymentType.PCL)
  const isInlinePaymentOptions = useIsInlinePaymentOptions()

  if (isRecoverableFlow) {
    return recoverableRoute
  }

  if (status < CheckoutStatus.Starting) {
    return Route.LOGGED_IN
  }

  if (!isConsumerLendingAllowInConvergence) {
    return Route.SUMMARY
  }

  // Original logic is to go this flow when BNPL declined but PM allowed. Instead, just disable it
  // if (isConsumerLendingEligible && isPayMonthlyOnly) {
  //   // route to pay monthly only flow in US region
  //   return Route.PAY_MONTHLY_ONLY
  // }

  // TODO: Account for both BNPL and PM allowed?
  if (isConsumerLendingEligible) {
    return isInlinePaymentOptions ? Route.PAYMENT_OPTIONS : Route.PAYMENT_TYPES
  }

  return Route.SUMMARY
}

export const useSummaryRoute = (): Route => {
  const isRecoverableFlow = useIsRecoverableFlow()
  const recoverableRoute = useRecoverableTerminalErrorRoute()

  if (isRecoverableFlow) {
    return recoverableRoute
  }

  return Route.SUMMARY
}
